    <aside class="sidebar">
      <div class="sidebar-brand">
        <app-brand-mark></app-brand-mark>
        <div>
          <div class="brand-name">Voyager B2B</div>
          <div class="brand-sub">Ops Console</div>
        </div>
        <button type="button" class="icon-btn sidebar-collapse-btn"
                (click)="app.toggleSidebar()" aria-label="Collapse navigation"
                title="Collapse">
          <app-icon name="ChevronLeft" [size]="16"></app-icon>
        </button>
      </div>

      <nav class="sidebar-nav">
        @for (g of groups(); track g.titleKey) {
          <div class="nav-section" [class.collapsed]="isCollapsed(g.titleKey)">
            <button type="button" class="nav-section-title"
                    [attr.aria-expanded]="!isCollapsed(g.titleKey)"
                    (click)="toggleGroup(g.titleKey)">
              <span>{{ g.titleKey | translate }}</span>
              <app-icon name="ChevronDown" [size]="12" class="nav-section-chevron"></app-icon>
            </button>
            @if (!isCollapsed(g.titleKey)) {
              @for (it of g.items; track it.id) {
                <div class="nav-item" [class.active]="isActive(it.id)"
                     [style.opacity]="it.disabled ? 0.45 : 1"
                     (click)="!it.disabled && navigate(it.id)">
                  <span class="nav-icon"><app-icon [name]="it.icon"></app-icon></span>
                  <span>{{ it.labelKey | translate }}</span>
                  @if (it.badge) {
                    <span class="nav-badge">{{ it.badge }}</span>
                  }
                  @if (it.disabled) {
                    <span class="nav-badge muted">{{ 'common.labels.soon' | translate }}</span>
                  }
                </div>
              }
            }
          </div>
        }
      </nav>

      <div class="sidebar-footer">
        <div class="avatar">{{ displayInitials() }}</div>
        <div class="user-meta">
          <div class="name">{{ displayName() }}</div>
          <div class="role">{{ displayRole() }}</div>
        </div>
        <button class="icon-btn tour-toggle" style="margin-left:auto"
                [class.tour-on]="pageTour.toursEnabled()"
                [class.tour-off]="!pageTour.toursEnabled()"
                [title]="pageTour.toursEnabled() ? 'Guided tours: ON — click to turn off' : 'Guided tours: OFF — click to turn on'"
                [attr.aria-pressed]="pageTour.toursEnabled()"
                aria-label="Toggle guided tours"
                (click)="pageTour.toggleTours()">
          <app-icon [name]="pageTour.toursEnabled() ? 'Compass' : 'EyeOff'"></app-icon>
        </button>
        <button class="icon-btn" style="color:var(--sidebar-fg-muted)"
                title="Sign out"
                (click)="logout()">
          <app-icon name="Logout"></app-icon>
        </button>
      </div>
    </aside>
